import React from 'react'
import './FeaturedBar.scss'
const FeaturedBar = ({ data }) => {
    return (
        <>
            <div className="featured-bar-wrapper">
                {data.map((item) => (
                    <div key={item.id} className="featuredBarColumn">
                        <div className="heading">
                            <h3>{item.title}</h3>
                        </div>
                        <a className="link primaryButtonLink" href={item.link}>
                            <span>{item.btnText}</span>
                        </a>
                    </div>
                ))}
            </div>
        </>
    )
}

export default FeaturedBar